import React from 'react';
import * as icons from '@heroicons/react/outline';

export type IconNames = keyof typeof icons;

interface IconProps {
  icon: IconNames;
  colorize?: 'stroke' | 'fill';
}

export const Icon: React.VFC<IconProps & React.SVGAttributes<SVGElement>> = (props) => {
  const { icon, colorize = 'stroke', ...restProps } = props;
  const Icon = icons[icon];
  const color = { [colorize]: 'currentColor' };

  return <Icon width={24} {...color} {...restProps} />;
};
